import { useState } from "react";

/**
 * Team logo with auto-fallback to ui-avatars when Clearbit (or any source) fails.
 */
export default function TeamLogo({ team, className = "", imgClassName = "", testid }) {
    const slug = (team.name || "Team").replace(/\s+/g, "+");
    const fallback = `https://ui-avatars.com/api/?name=${slug}&background=ff4500&color=fff&bold=true&size=256&format=svg`;
    const [src, setSrc] = useState(team.logo || fallback);

    return (
        <div className={className} data-testid={testid}>
            <img
                src={src}
                alt={`${team.name} logo`}
                className={imgClassName}
                loading="lazy"
                onError={() => { if (src !== fallback) setSrc(fallback); }}
            />
        </div>
    );
}
